import React, { useCallback, useEffect } from 'react'
import { useParams, RouteChildrenProps } from 'react-router-dom'
import useAPIRequest from '../../../../hooks/useAPIRequest'
import API from '../../../../services/api'
import LoadingSpinner from '../../../atoms/loadingspinner/LoadingSpinner'
import ParticipantForm from './ParticipantForm'
import Container from '../../../atoms/page/Page'
import Banner from '../../../atoms/banner/Banner'

function AddParticipant(props: RouteChildrenProps) {
  const { eventId } = useParams<{ eventId: string }>()

  const callback = useCallback(() => {
    return API.getEvent(eventId)
  }, [eventId])

  const [{ inProgress, data, error}, doApiRequest] = useAPIRequest(callback, null)

  useEffect(() => {
    doApiRequest()
  }, [doApiRequest])

  return (
    <Container>
      {inProgress && <LoadingSpinner />}
      {error && <Banner type='error' active message={error.message} />}
      {!inProgress && data && <ParticipantForm event={data} {...props}/>}
    </Container>
  )
}

export default AddParticipant
